var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getSelectedTeamAccount } from '../../../selectors/uiSelector';
import { OnboardingStep } from '../../../types/GloblalTypes';
import { AdminPageSubpageContentContainer } from '../../AdminPage/AdminPageStyles';
import { SetupOptionId } from './EmOnboardingPageData';
import OnboardingContainerV1 from '../Onboarding/Onboarding';
import QuickStart from './QuickStart/QuickStart';
import SelectSetupContainer from './Selection/SelectSetupContainer';
import { QuickStartSuccess } from './QuickStart/QuickStartSuccess';
import { EXTERNAL_ROUTES, PORTAL_ROUTE_PREFIX } from '../../../constants/values';
import { useSetOnboardingStepMutation } from '../Onboarding/useSetOnboardingStepMutation';
import { useOnboardingContext } from '../../TeamAccountPlanDetails/TeamAccountConfigurationContext';
var EmOnboarding = function (_a) {
    var onboardingVersion = _a.onboardingVersion, isEmInvoicing = _a.isEmInvoicing, isOnboardingInProgress = _a.isOnboardingInProgress, completedSteps = _a.completedSteps;
    var history = useHistory();
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var _b = useOnboardingContext(), showQuickSetupSuccess = _b.showQuickSetupSuccess, setShowQuickSetupSuccess = _b.setShowQuickSetupSuccess, reloadCompletedOnboardingSteps = _b.reloadCompletedOnboardingSteps;
    var _c = __read(React.useState(null), 2), setupOption = _c[0], setSetupOption = _c[1];
    var setFinishOnboardingStep = useSetOnboardingStepMutation(teamAccountId, OnboardingStep.ONBOARDING_STEP_FINISH_ONBOARDING, {
        refetchQueries: null,
        onCompleted: function () {
            setShowQuickSetupSuccess(true);
        },
    }).setOnboardingStep;
    var onStartOrderClick = function () {
        // hide onboarding page and tab
        reloadCompletedOnboardingSteps === null || reloadCompletedOnboardingSteps === void 0 ? void 0 : reloadCompletedOnboardingSteps();
        // open marketplace in new tab
        redirectToMarketplace();
    };
    var redirectToMarketplace = function () {
        // open marketplace in new tab
        window.open(EXTERNAL_ROUTES.MARKETPLACE, '_blank');
    };
    var redirectToEmployeesTab = function () {
        history.push(PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/members");
    };
    if (showQuickSetupSuccess) {
        return (React.createElement(AdminPageSubpageContentContainer, null,
            React.createElement(QuickStartSuccess, { onStartOrderClick: onStartOrderClick, onManageEmployeesClick: redirectToEmployeesTab })));
    }
    // when user has completed a step in guided setup, keep them in guided setup
    if (isOnboardingInProgress) {
        return (React.createElement(AdminPageSubpageContentContainer, null,
            React.createElement(OnboardingContainerV1, { onboardingVersion: onboardingVersion })));
    }
    if (!setupOption) {
        return (React.createElement(AdminPageSubpageContentContainer, null,
            React.createElement(SelectSetupContainer, { onSelectedSetupOptionId: setSetupOption })));
    }
    if (setupOption === SetupOptionId.quickStart) {
        return (React.createElement(AdminPageSubpageContentContainer, null,
            React.createElement(QuickStart, { hidePaymentMethod: isEmInvoicing, teamAccountId: teamAccountId, onBack: function () { return setSetupOption(null); }, completeOnboarding: setFinishOnboardingStep })));
    }
    // setup option === guided setup
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(OnboardingContainerV1, { onboardingVersion: onboardingVersion, onBack: completedSteps.length === 0 ? function () { return setSetupOption(null); } : null })));
};
export default EmOnboarding;
